<pui-page-header [title]="'Grupy'">
  <pui-breadcrumbs>
    <a pui-breadcrumbs-item href="/">
      <pui-icon icon="home-line" />
    </a>
    <a pui-breadcrumbs-item href="/">Grupy</a>
  </pui-breadcrumbs>
  <button pui-button variant="primary" (click)="onAddGroup()">Dodaj grupę<pui-icon icon="plus" left /></button>
</pui-page-header>

<div class="page-container">
  <pui-table2 [dataSource]="filteredGroups()" [trackBy]="trackBy" [sortBy]="sort().key"
    [sortDirection]="sort().direction" (sortChange)="onSortChange($event)">
    <ng-container header>
      <form class="d-flex align-items-center gap-16 justify-content-between w-100" [formGroup]="filtersForm">
        <pui-form-field>
          <pui-label>Wyszukaj</pui-label>
          <pui-icon icon="search-md" left />
          <input puiInput placeholder="Wyszukaj" formControlName="global" />
        </pui-form-field>
        <pui-divider />
        <pui-form-field>
          <pui-label>Typ grupy</pui-label>
          <pui-select [multiple]="false" formControlName="groupValue">
            <pui-placeholder>Typ</pui-placeholder>
            <pui-option [value]="">Wszystkie</pui-option>
            @for(option of groupTypeOptions; track $index){
            <pui-option [value]="option">{{option}}</pui-option>
            }
          </pui-select>
        </pui-form-field>
      </form>
    </ng-container>
    <ng-template #header>
      <th>Nazwa grupy</th>
      <th>Typ</th>
      <th>Data utworzenia</th>
      <th>Jednostka</th>
      <th>Członkowie</th>
      <th>Akcje</th>
    </ng-template>
    <ng-template #row let-row>
      <tr>
        <td>
          <button (click)="onToggleRow(row)" pui-button variant="tertiary">
            <pui-icon [icon]="isExpanded(row) ? 'chevron-down' : 'chevron-right'"></pui-icon>
          </button>
          {{ row.name }}
        </td>
        <td>{{ row.groupValue }}</td>
        <td>{{ row.creationDate | date: 'dd.MM.yyyy' }}</td>
        <td>{{ row.responsibleUnit }}</td>
        <td>{{ row.usersCount }}</td>
        <td>
          <button pui-button variant="tertiary" (click)="onEditGroup(row)"><pui-icon left icon="edit-03"
              class="action-icon" /></button>
          <button pui-button variant="tertiary" (click)="onDeleteGroup(row)"><pui-icon left icon="trash-03"
              class="remove-icon" /></button>
        </td>
      </tr>

      <tr *ngIf="isExpanded(row)" class="detail-row">
        <td colspan="6">
          <rqa-group-list-details [groupUsers]="row.webRqaUsers" [groupId]="row.id"
            (deleteUser)="onDeleteUserFromGroup($event)"></rqa-group-list-details>
        </td>
      </tr>
    </ng-template>
    <pui-empty-state icon="file-x-02" title="Nie masz jeszcze żadnych grup">
      <button pui-button variant="primary" (click)="onAddGroup()">Dodaj grupę<pui-icon icon="plus" class="remove-icon"
          left /></button>
    </pui-empty-state>
  </pui-table2>
</div>